import { MOBILE_MODE } from '@constants/size';
import styled from '@emotion/styled';
import { gray } from '@styles/Colors';
import { Radius } from '@styles/Radius';

type Props = Styleable & {
  readonly height?: string;
  readonly name?: string;
  readonly value?: string;
  readonly placeholder?: string;
  readonly disabled?: boolean;
  readonly onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

const TextAreaComponent = styled.textarea<{ height?: string }>`
  height: ${({ height }) => height || '160px'};
  border: 1px solid ${gray.gray4};
  border-radius: ${Radius.MEDIUM};
  padding: 14px 16px;
  resize: none;
  font-size: 14px;
  font-family: 'Pretendard Variable';

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${gray.gray4};
  }

  &:disabled {
    background: ${gray.gray1};
  }

  @media ${MOBILE_MODE} {
    height: ${({ height }) => height || '132px'};
  }
`;

export default function TextArea({ height, name, value, disabled, placeholder, onChange }: Props) {
  return (
    <TextAreaComponent
      height={height}
      name={name}
      value={value}
      disabled={disabled}
      placeholder={placeholder}
      onChange={onChange}
    />
  );
}
